import { Badge } from '@kerfjs/ui/badge';
import { type SafeHtml } from 'kerfjs';

export function DecidedBadges({
  decidedCount,
  total,
  allDecided,
}: {
  decidedCount: number;
  total: number;
  allDecided: boolean;
}): SafeHtml {
  return (
    <>
      <Badge tone="neutral" appearance="solid" shape="pill">
        {`${String(decidedCount)} of ${String(total)} decided`}
      </Badge>
      {allDecided ? (
        <Badge tone="success" appearance="solid" shape="pill">
          All lines decided
        </Badge>
      ) : null}
    </>
  );
}
